import React, { useState } from "react";
import styles from "./index.module.css";
import Button from "../../../Components/Button";
import { IoClose } from "react-icons/io5";
import Loader from "../../../Components/Loader";
import { useDispatch } from "react-redux";
import { rejectTrip } from "../../Home/homeActions";
import { useTranslation } from "react-i18next";
import SwipeButton from "../../../Components/SwipeButton";

const RejectionReason = ({ reasons, tripId, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loader, toggleLoader] = useState(false);
  const [note, setNote] = useState("");

  const handleRejectTrip = () => {
    toggleLoader(true);
    dispatch(rejectTrip(tripId, note, () => toggleLoader(false)));
  };

  return (
    <div className={styles["rejection-reason_trip"]}>
      <span className={styles["rejection-reason_trip-close"]}>
        <Button
          type={"button"}
          transparentGreyButton
          roundedButton
          fitChild
          onClick={onClose}
        >
          <IoClose size={32} color={"#3D5973"} />
        </Button>
      </span>
      <label className={styles["rejection-reason_trip-label"]}>
        {t("Select a rejection reason")}
      </label>
      {loader ? (
        <Loader spinner />
      ) : (
        <section className={styles["rejection-reason_trip--reasons"]}>
          {reasons?.map((item, key) => (
            <Button
              key={key}
              lightButton={item?.reason === note ? false : true}
              shadow
              maxRadius
              onClick={() => setNote(item?.reason)}
              className={styles["rejection-reason__button-font"]}
            >
              {item?.reason}
            </Button>
          ))}
        </section>
      )}
      <SwipeButton
        label={t("Reject")}
        onComplete={handleRejectTrip}
        disabled={!note}
        loader={loader}
      />
    </div>
  );
};

export default RejectionReason;
